<ngx-loading-bar color="#CD67BA" height="5px" [includeSpinner]="false" ref="router"></ngx-loading-bar>
<ngx-loading-bar color="#CD67BA" height="5px" ref="http" [includeSpinner]="true"></ngx-loading-bar>
<!--  
<spartan-app-sidebar-inset>
      <main hlmSidebarInset>
        <spartan-site-header-inset />
        <div class="flex flex-1 flex-col gap-4 p-4">
            <router-outlet #o="outlet"></router-outlet>
          <div class="grid auto-rows-min gap-4 md:grid-cols-3">
            <div class="bg-muted/50 aspect-video rounded-xl"></div>
            <div class="bg-muted/50 aspect-video rounded-xl"></div>
            <div class="bg-muted/50 aspect-video rounded-xl"></div>
          </div>
          <div
            class="bg-muted/50 min-h-screen flex-1 rounded-xl md:min-h-min"
          ></div>
        </div>
      </main>
    </spartan-app-sidebar-inset>-->

<div [class]="'theme-wrapper ' + (theme$ | async)">
  <header>
    <div class="toolbar" [style.position]="(stickyHeader$ | async) ? 'fixed' : 'inherit'"
      [class.mat-elevation-z4]="(stickyHeader$ | async)">
      <mat-toolbar color="primary">
        @if (isInitial$ |async; as isInitial) {
          <button class="hamburger pl-2 pl-3-sm" mat-icon-button (click)="toggleSidenav()">
            <mat-icon>menu</mat-icon>
          </button>
        }

        <div class="branding-mobile  d-inline d-sm-none mobile-branding">
          <span routerLink="" class="branding spacer center">
            KVASAR
          </span>
        </div>

        <div>
          <div class="branding-mobile d-flex flex-row">
           
          <span routerLink="" class="branding spacer center d-none d-sm-inline d-md-none">
            <img [src]="logo" />
            {{'anms.title.short' | translate }}
          </span>
        </div>

        <div class="branding spacer d-none d-md-flex">
       
        <img [src]="logo" class="ml-5" />
        <div class="title " routerLink="">
          <p class="title-main">KVASAR</p>
          <p class="title-label">{{ 'anms.title.long' | translate }}</p>
        </div>
      </div>
    </div>

    <div>
      @if ((isAuthenticated$ | async); as authenticated) {
        <anms-menu></anms-menu>
        <button mat-icon-button (click)="openAccountMenu()">
          <fa-icon icon="user-circle"></fa-icon>
        </button>
      } @else {
        @if (language$ | async; as language) {
          <span class="lang-select pr-3">
            <span class="material-icons pr-1 pt-2"  style="color: white">
              language
            </span>
            <mat-select [ngModel]="language" (selectionChange)="onLanguageSelect($event)" style="color: white">
              @for (l of languages; track l) {
                <mat-option [value]="l">
                  {{ l.toUpperCase() }}
                </mat-option>
              }
            </mat-select>
          </span>
        }
      }



    </div>
 
  </mat-toolbar>
</div>
</header>
<main cdkScrollable>
  <div class="content"
    [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
    <router-outlet #o="outlet"></router-outlet>
  </div>
  <div class="footer" style="display: none;">
      <div class="row">
      <div class="col-12 signature">
        &#169; <span class="year">{{year}}</span> - Jordi Marti
        <br class="d-block d-sm-none">
        <a [matTooltip]="'anms.footer.changelog' | translate" matTooltipPosition="before"
          href="https://github.com/tomastrajan/angular-ngrx-material-starter/blob/master/CHANGELOG.md">
          <fa-icon icon="rocket"></fa-icon>
          {{version}} @if (!isProd) {
          <span>[{{envName}}]</span>
        }
      </a>
    </div>
  </div>
</div>

</main>
</div>
